<template>
  <div class="spo-card rounded bordered p-1 my-2">
    <!-- Alerte de notification pour les utilisateurs lors d'un changement de parcours -->
    <div class="text-h6">Garantie Individuelle d'Annulation</div>
    <div>
      <v-alert v-if="is_changement_parcours && !has_already_gia" border="start" border-color="primary-dark"
        elevation="1">Vous n'aviez pas souscrit à la GIA pour votre première inscription, elle n'est donc pas disponible
        pour ce nouveau parcours</v-alert>
      <v-alert v-else-if="is_changement_parcours && has_already_gia && need_to_pay_difference_gia" border="start"
        border-color="primary-dark" elevation="1">Vous aviez déjà souscrit à la GIA sur le précédent parcours pour un
        montant de {{ initial_commande_inscription.gia.prix }}€. Le montant de la GIA pour ce nouveau parcours étant
        plus
        élevé ({{ default_gia_price }}€), en cochant la case
        ci-dessous, vous paierez la différence pour continuer à profiter de ce service, soit {{
          (parseFloat(default_gia_price) - parseFloat(initial_commande_inscription.gia.prix)).toFixed(1) }}€. Dans le cas
        contraire, elle sera perdue.</v-alert>
      <v-alert v-else-if="is_changement_parcours && has_already_gia && !need_to_pay_difference_gia" border="start"
        border-color="primary-dark" elevation="1">Vous aviez déjà souscrit à la GIA pour le précedent parcours. Elle
        sera
        transféré pour l'inscription à ce nouveau parcours</v-alert>
    </div>

    <div v-if="!is_changement_parcours || (is_changement_parcours && has_already_gia && need_to_pay_difference_gia)">
      <v-checkbox v-if="!is_changement_parcours" color="primary-dark" hide-details @change="$emit('changeGIA')"
        :label="'Souscrire à la GIA pour ' + gia.prix + '€'" v-model="gia.selected"></v-checkbox>
      <v-checkbox v-if="is_changement_parcours && has_already_gia && need_to_pay_difference_gia" color="primary-dark"
        hide-details @change="$emit('changeGIA')"
        :label="'Etendre ma GIA pour ' + parseFloat(gia.prix).toFixed(1) + '€'" v-model="gia.selected"></v-checkbox>

      <p v-if=has_increment_remboursement>
        En choisissant cette option, vous complétez votre inscription par une Garantie Individuelle d'Annulation qui
        vous
        permettra d'être remboursé du montant<span v-if="has_increment_remboursement">, ou d'une partie du
          montant,</span> de votre dossard
        <b>sur simple demande de votre part, selon les modalités suivantes.</b>
      </p>
      <p v-else>
        En choisissant cette option, vous complétez votre inscription par une Garantie Individuelle d'Annulation qui
        vous
        permettra d'être remboursé du montant de votre dossard
        <b>sur simple demande de votre part, sans justificatif jusqu'à {{ delai_gia }}h avant le départ de votre
          course.</b>
      </p>

      <v-dialog v-model="showDialogGIA" width="500" max-width="100%" scroll-strategy="none">
        <template v-slot:activator="{ props }">
          <v-btn color="darkblue" variant="plain" size="small" v-bind="props"><v-icon icon="mdi-information-outline"
              class="mr-1" size="large"></v-icon>Modalités de la GIA </v-btn>
        </template>

        <v-card>
          <v-card-text>
            <div class="text-h6">Inscription remboursable</div>
            <p>
              - Covid-19<br />
              - Maladie<br />
              - Accident ou blessure<br />
              - Empêchement professionnel<br />
              - Conditions météo défavorables<br />
              - Autres<br />
            </p>
            <div class="text-h6">Conditions générales</div>

            <ul v-if="mainStore.module.base == 'MAXIRACE26'">
              <li>Jusqu’au 19 Avril inclus : Remboursement de votre inscription à 100%</li>
              <li>Jusqu’au 10 Mai inclus : Remboursement de votre inscription à 70%</li>
              <li>Jusqu’au 24 Mai inclus : Remboursement de votre inscription à 50%</li>

            </ul>
            <ul v-if="mainStore.module.base == 'ATLANTIC26'">
              <li>Jusqu’au 20 janvier inclus : Remboursement de votre inscription à 100%</li>
              <li>Jusqu’au 7 février inclus : Remboursement de votre inscription à 70%</li>
              <li>Jusqu’au 20 février inclus : Remboursement de votre inscription à 50%</li>
              <li>Plus de remboursement après le 20 février</li>
            </ul>


            <ul v-if="mainStore.module.base == 'VVX27'">
              <li>Jusqu’au 26 mars inclus : Remboursement de votre inscription à 100%</li>
              <li>Jusqu’au 15 avril inclus : Remboursement de votre inscription à 70%</li>
              <li>Jusqu’au 30 avril inclus : Remboursement de votre inscription à 50%</li>
              <li>Plus de remboursement après le 30 avril 2027</li>
            </ul>
            <ul v-if="mainStore.module.base == 'VICH27'">
              <li>Jusqu’au 8 février inclus : Remboursement de votre inscription à 100%</li>
              <li>Jusqu’au 28 février inclus : Remboursement de votre inscription à 70%</li>
              <li>Jusqu’au 15 mars inclus : Remboursement de votre inscription à 50%</li>
              <li>Plus de remboursement après le 15 mars 2027</li>
            </ul>



            <p>
              Votre inscription remboursée sans justificatif depuis votre fiche d'inscription sur sportips.fr ou sur
              demande
              dans la rubrique Contact. Les options (Repas, navette, etc...) ne seront pas remboursées. <br />
              Si vous n'avez pas choisi cette option, vous ne pourrez pas demander le remboursement de votre
              inscription.<br />
              En cas d'annulation ou report général de l'épreuve, les conditions générales de l'organisateur
              s'appliquent...
              (remboursements, report, autres... indiqué dans le règlement de l'épreuve)
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" block @click="showDialogGIA = false">Fermer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  props: ["item", "initial_commande_inscription"],
  data() {
    return {
      showDialogGIA: false,
      gia: {},
      default_gia_price: 0,
      delai_gia: 72,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    has_increment_remboursement() {
      const base = this.mainStore.module.base;
      if (base == 'ATLANTIC26' || base == 'MAXIRACE26' || base == 'VVX27' || base == 'VICH27') {
        return true;
      }
      return false;
    },
    is_changement_parcours() {
      return this.initial_commande_inscription;
    },
    has_already_gia() {
      return this.initial_commande_inscription && this.initial_commande_inscription.gia && this.initial_commande_inscription.gia.valide == "1";
    },
    propose_gia_changement_parcours() {
      if (!this.initial_commande_inscription) {
        return true;
      }
      if (!this.initial_commande_inscription.gia) {
        return false;
      }
      if (this.initial_commande_inscription.gia.valide == "0") {
        return false;
      }
      return true;
    },

    need_to_pay_difference_gia() {
      return parseFloat(this.initial_commande_inscription.gia.prix) < parseFloat(this.default_gia_price);
    },
  },
  created() {
    this.gia = this.item;
    this.default_gia_price = parseFloat(this.gia.prix);
    this.delai_gia = this.mainStore.module.dernier_delai_gia ? this.mainStore.module.dernier_delai_gia : 72;
    if (this.is_changement_parcours && this.has_already_gia && this.need_to_pay_difference_gia) {
      this.gia.prix = parseFloat(this.gia.prix) - parseFloat(this.initial_commande_inscription.gia.prix);
      this.gia.prix = parseFloat(this.gia.prix).toFixed(1);
    }
  },
};
</script>

<style lang="scss" scoped></style>